import { compress } from "micro-graphql-react"

export default compress`
  query($tailoredAssignmentId: ID!) {
    tailoredAssignment(id: $tailoredAssignmentId) {
      name
    }
    tailoredSectionSummaries(tailoredAssignmentId: $tailoredAssignmentId) {
      correctCount
      incorrectCount
      skippedCount
      studentScore
      reviewPath
      tailoredSection {
        id
        name
      }
    }
  }
`
